<template>
    <div>
        <a-modal v-model:visible="visible" title="填报数据" width="40%" :footer="false">
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between" :gutter="12">
                        <a-col span="12">
                            <a-input-search v-model="param.keyword" allowClear search @pressEnter="doRefresh"
                                @on-clear="doRefresh" placeholder="关键词查询" @search="doRefresh"
                                enter-button></a-input-search>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
            <div>
                <a-table :columns="keys" rowKey="id" :pagination="false" :data-source="data.records" size="small"
                    :loading="loading">
                    <template slot-scope="row" slot="action">
                        <a-tooltip title="填报详情">
                            <a-button type="link" icon="eye" @click="$refs.detail.show(row.id)"></a-button>
                        </a-tooltip>
                    </template>
                </a-table>
            </div>
            <a-row>
                <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                    <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                        @showSizeChange="setLimit" :current="data.current" size="small" simple />
                </a-col>
            </a-row>
        </a-modal>
        <collection-detail ref="detail"></collection-detail>
    </div>
</template>

<script>
import utils from '@/common/utils';
import collectionDetail from './collection-detail.vue';
export default {
    components: {
        collectionDetail
    },
    data() {
        return {
            loading: false,
            visible: false,
            data: { records: [] },
            param: {
                page: 1,
                limit: 20,
                keyword: '',
            },
            keys: [
                { title: '任务名称', dataIndex: 'title', align: 'left', tooltip: true, ellipsis: true },
                { title: '填报人', dataIndex: 'name', align: 'center', width: 200, tooltip: true, ellipsis: true },
                { title: '手机号', dataIndex: 'phone', align: 'center', width: 120, tooltip: true, ellipsis: true },
                { title: '填报时间', dataIndex: 'createTime', width: 160, ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 100 }
            ],
        }
    },
    methods: {
        show(colId) {
            this.param.colId = colId;
            this.doRefresh();
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        getList() {
            utils.showSpin();
            this.loading = true;
            this.http.get("/platform/collection/data/list", this.param).then(ret => {
                // console.log(ret)
                this.data = ret.data;
                this.visible = true;
            }).finally(() => {
                utils.closeSpin();
                this.loading = false;
            });
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
}
</script>

<style></style>